import { tw } from './zh_tw'
import { cn } from './zh_cn'
import { en } from './us_en'

export const locales = {
  tw: tw,
  en: en,
  cn: cn
}



// WEBPACK FOOTER //
// ./src/locales/langs.js